const classicItems = [
  'Reklam görseli hazırlar',
  'Reklam metni yazar',
  'Kampanya açar',
  'Gelen mesaj sayısına bakar',
  'Çoğu zaman lead kalitesini ölçmez',
  'Satış sürecinden kopuk ilerler',
];

const systemItems = [
  'Reklamdan gelen kişiyi karşılar',
  'Mesaj ve etkileşim davranışını analiz eder',
  'Potansiyel müşteri kalitesini ölçer',
  'Olumlu, olumsuz, satışa yakın kişileri ayırır',
  'Veriyi tekrar reklam sistemine gönderir',
  'Reklam + satış sürecini birlikte yönetir',
];

export default function DifferenceSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100" id="farkimiz">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Biz Reklamı Sadece Yayına Almıyoruz,
            <br />
            <span className="text-accent-600">Gelen Kişiyi Analiz Ediyoruz.</span>
          </h2>
          <p className="text-foreground-600 max-w-3xl mx-auto text-sm md:text-base leading-relaxed">
            Reklam görseli hazırlamak, kampanya metni yazmak veya içerik üretmek artık tek başına yeterli değil. Yapay zeka ile birçok kişi temel seviyede reklam içeriği oluşturabilir. Bizim asıl odaklandığımız yer, reklamdan gelen kişinin davranışını analiz etmek ve bu veriyi tekrar reklam sistemine geri döndürmektir.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          <div className="rounded-2xl border border-background-300/60 bg-background-50 p-6 md:p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-lg bg-foreground-100 flex items-center justify-center">
                <i className="ri-building-2-line text-foreground-500 text-lg"></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-800 text-lg">
                Klasik Reklam Ajansı
              </h3>
            </div>
            <ul className="space-y-3">
              {classicItems.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-foreground-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-close-line text-foreground-400 text-xs"></i>
                  </div>
                  <span className="text-foreground-600 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border border-accent-200/50 bg-primary-500 p-6 md:p-8 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-accent-500/20 rounded-full -translate-y-1/2 translate-x-1/2 blur-2xl"></div>
            <div className="relative z-10">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-lg bg-accent-500 flex items-center justify-center">
                  <i className="ri-brain-line text-background-50 text-lg"></i>
                </div>
                <h3 className="font-heading font-bold text-background-50 text-lg">
                  Davranış Analizi Destekli Sistem
                </h3>
              </div>
              <ul className="space-y-3">
                {systemItems.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <div className="w-5 h-5 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-background-50 text-xs"></i>
                    </div>
                    <span className="text-background-50/90 text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}